module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-div-table__holder-section"
  }, [_c('div', {
    staticClass: "flex-grid__g-2"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("\n            Type\n        ")]), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-2"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Percentage")]), _vm._v(" "), (_vm.updates !== 'generalDamages') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInterest),
      expression: "userInterest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userInterest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.25
    }
  }, [_vm._v("0.25%")])]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInterest),
      expression: "userInterest"
    }],
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userInterest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2.00%")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Value")]), _vm._v(" "), (_vm.value > 0) ? _c('control', {
    attrs: {
      "endpoint": _vm.endpoint,
      "icon-space": _vm.theCurrentWidth < 1024 ? false : true,
      "modal-name": 'interest_' + _vm.uniqueId,
      "payload": _vm.payload,
      "option": _vm.option,
      "table-control": true,
      "tip-name": _vm.tipName,
      "before-after": "pound",
      "label": "",
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (parseFloat(_vm.value) === 0) ? _c('control', {
    attrs: {
      "label": "",
      "table-control": true,
      "tip-icon": "default",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a81d6bc2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InterestItem.vue
// module id = 1784
// module chunks = 0